/**
 * sl-728o.7.3: AI Chat Tutorial Session
 *
 * 5 steps guiding the user through the AI chat sidebar.
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';
import {
  ensureAiChatOpen,
  resolveAiChatInput,
  resolveAiChatPanel,
} from './targets';

type I18n = ReturnType<typeof useI18n>;

export function createAiChatSession(t: I18n): TutorialSession {
  return {
    id: 'tutorial:ai-chat',
    context: {
      targetAudience: 'all',
      category: 'basics',
    },
    steps: [
      {
        targetSelector: '[data-testid="ai-island"]',
        title: t['com.streamlain.streamlain.tutorial.ai-chat.step1.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.ai-chat.step1.content'](),
        animation: 'pulse',
        trigger: { type: 'manual' },
        position: 'left',
      },
      {
        targetResolver: resolveAiChatPanel,
        title: t['com.streamlain.streamlain.tutorial.ai-chat.step2.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.ai-chat.step2.content'](),
        animation: 'highlight',
        onEnter: ensureAiChatOpen,
        delay: 350,
        trigger: { type: 'manual' },
        position: 'left',
      },
      {
        targetResolver: resolveAiChatInput,
        title: t['com.streamlain.streamlain.tutorial.ai-chat.step3.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.ai-chat.step3.content'](),
        animation: 'pulse',
        trigger: { type: 'manual' },
        position: 'left',
      },
      {
        targetResolver: resolveAiChatPanel,
        title: t['com.streamlain.streamlain.tutorial.ai-chat.step4.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.ai-chat.step4.content'](),
        animation: 'none',
        trigger: { type: 'manual' },
        position: 'left',
      },
      {
        targetResolver: resolveAiChatPanel,
        title: t['com.streamlain.streamlain.tutorial.ai-chat.step5.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.ai-chat.step5.content'](),
        animation: 'none',
        trigger: { type: 'manual' },
        position: 'left',
      },
    ],
  };
}
